$(document).ready(function () {

    function initializeEmptyCartSwiper() {
        if (document.querySelector('.empty-coll-swiper')) {
            var swiperEmpty = new Swiper(".empty-coll-swiper", {
                slidesPerView: 1.1,
                spaceBetween: 10,
                grabCursor: true,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                    draggable: true,
                },
            });
        }
    }

    initializeEmptyCartSwiper();
  
    function cartDrawerOpen() {
        $('.cart-drawer').addClass('show')
        $('.cart-drawer__icon-close').on('click', cartDrawerClose)
        $('.cart-drawer__backdrop').on('click', cartDrawerClose)
        $('body').addClass('hidden-overflow').on('change', '.upgrade-to-subscription', upgradeToSubscription).on('change', '.selling-plan', function () {
            ajaxUpdateSellingPlan($(this).data('line-id'), $(this).val());
        })
        $('.modal-universal').removeClass('show')
        if (cartEmpty) {
            $('.cart-drawer__empty-btn').on('click', cartDrawerClose)
        } else {
            $('.cart-drawer__btn--continue').on('click', cartDrawerClose)
            $('.cart-drawer__product-quantity-btn--minus').on('click', handleMinusQuantity)
            $('.cart-drawer__product-quantity-btn--plus').on('click', handlePlusQuantity)
            $('.cart-drawer__product-remove').on('click', handleRemove)
        }
    }

    function getCurrentCartCount() {
        return Number($('.header__icons-item-icon-cart-count').text())
    }

    async function addToCart(e) {
        e.preventDefault()
        let addToCartForm = e.currentTarget;
        let formData = new FormData(addToCartForm);

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
            const data = await response.json();
            let quantity = Number(formData.get('quantity'))
            if (quantity === 0) {
                quantity = 1;
            }
            await cartDrawerUpdateMarkup(getCurrentCartCount() + quantity)
            // cartDrawerOpen()

            //   Cart Update issue start for cart sometimes randomly not opening. commented upper cartDrawerOpen()
            const cartIcon = document.querySelector('.header__icons-item-link.cart');
            if (cartIcon) {
                cartIcon.click();
            }

            setTimeout(() => {
                if (!document.body.classList.contains('amp-cart--open')) {
                    document.body.classList.add('amp-cart--open');
                }
            }, 500);

            let forceOpenCount = 0;
            const ampCartObserver = new MutationObserver(function() {
                if (!document.body.classList.contains('amp-cart--open')) {
                    if (forceOpenCount < 5) {
                        forceOpenCount++;
                        document.body.classList.add('amp-cart--open');
                    } else {
                        ampCartObserver.disconnect();
                    }
                }
            });
            ampCartObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
            setTimeout(function() { ampCartObserver.disconnect(); }, 1000);

            cartDrawerUpdateMarkup(getCurrentCartCount() + quantity);
        //   Cart Update issue end
        } catch (er) {
            console.error('Error:', er);
        }
    }

    function cartDrawerClose() {
        $('.cart-drawer').removeClass('show')
        $('body').removeClass('hidden-overflow')
        $('.close-cart-drawer').off('click')
        $('.cart-drawer__backdrop').off('click')
        $('.cart-drawer__product-quantity-btn--plus').off('click')
        $('.cart-drawer__product-quantity-btn--minus').off('click')
        $('.cart-drawer__product-remove').off('click')
        $('.cart-drawer__empty-btn').off('click')
        $('.cart-drawer__btn--continue').off('click')
        $('.upgrade-to-subscription').off('change')
        $('.selling-plan').off('change')
    }

    function handlePlusQuantity() {
        const variantId = $(this).attr('data-item')
        const variantKey = $(this).attr('data-key')
        const inputQuantityValue = Number($(`.cart-drawer__product-input-quantity[data-item= ${variantId}]`).val())

        cartDrawerUpdateQuantity(variantKey, inputQuantityValue + 1)
    }

    function handleMinusQuantity() {
        const variantId = $(this).attr('data-item')
        const variantKey = $(this).attr('data-key')
        const inputQuantityValue = Number($(`.cart-drawer__product-input-quantity[data-item= ${variantId}]`).val())

        cartDrawerUpdateQuantity(variantKey, inputQuantityValue - 1)
    }

    function handleRemove() {
        const variantKey = $(this).attr('data-key')
        cartDrawerUpdateQuantity(variantKey, 0)
    }


    async function cartDrawerUpdateMarkup(quantity) {
        try {
            const response = await fetch('/?sections=cart-drawer')
            const data = await response.json()
            const html = new DOMParser().parseFromString(data["cart-drawer"], 'text/html');
            const sourceQty = html.querySelector('.cart-drawer___container');

            document.querySelector('.cart-drawer___container').innerHTML = sourceQty.innerHTML;
            $('.cart-drawer__icon-close').on('click', cartDrawerClose)
            $('.cart-drawer__empty-btn').on('click', cartDrawerClose)
            $('.header__icons-item-icon-cart-count').text(`${quantity}`)

            $('.cart-drawer__product-quantity-btn--minus').on('click', handleMinusQuantity)
            $('.cart-drawer__product-quantity-btn--plus').on('click', handlePlusQuantity)
            $('.cart-drawer__product-remove').on('click', handleRemove)
          
            if (quantity === 0) {
              $('form[action$="/cart/add"]').off('submit', addToCart).on('submit', addToCart);
              $('form[action$="/cart/add"]').on('submit', addToCart)
              initializeEmptyCartSwiper();
            }
          
            caloriesProcess()
            window.Rebuy.init()
            giftProductProcess()
          
        } catch (er) {
            console.error(er);
        }

    }

    function cartDrawerUpdateQuantity(variantKey, count) {
        const data = {
            "id": variantKey,
            "quantity": count
        }

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                const cartItemCount = data["item_count"]
                cartDrawerUpdateMarkup(cartItemCount)
            })
            .catch(error => error)
        $(document).trigger('cartUpdated');

    }

    function rebuyAddedProduct() {
        const currentCartCount = getCurrentCartCount()
        cartDrawerUpdateMarkup(currentCartCount + 1)
    }

    function rebuyRemovedProduct() {
        const currentCartCount = getCurrentCartCount()
        cartDrawerUpdateMarkup(currentCartCount - 1)
    }

    function caloriesProcess() {
        fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                //here my main goal was to find out metafields of products, only this way I can find it
                const allProductInCart = document.querySelectorAll('.cart-drawer__product')
                let itemsInCart = {}

                allProductInCart.forEach(el => {
                    const id = el.dataset.id
                    const quantity = el.dataset.quantity
                    const title = el.dataset.title
                    const variantTitle = el.dataset.varianttitle
                    const caloriesProduct = el.dataset.caloriesproduct
                    const caloriesVariant = el.dataset.caloriesvariant
                    const sugarProduct = el.dataset.sugarproduct
                    const sugarVariant = el.dataset.sugarvariant
                    const carbsProduct = el.dataset.carbsproduct
                    const carbsVariant = el.dataset.carbsvariant
                    const tags = el.dataset.tags

                    itemsInCart[id] = {
                        "quantity": quantity,
                        "title": title,
                        "variant_title": variantTitle,
                        "caloriesProduct": caloriesProduct,
                        "caloriesVariant": caloriesVariant,
                        "SugarProduct": sugarProduct,
                        "SugarVariant": sugarVariant,
                        "CarbsProduct": carbsProduct,
                        "CarbsVariant": carbsVariant,
                        "tags": tags
                    }
                })

                let total_saving_carbs_cart = 0;
                let total_saving_sugars_cart = 0;
                let total_saving_calories_cart = 0;

                //here I searched for beer packs, is it packs in title
                let beerPacks = [];
                for (const [id, item] of Object.entries(itemsInCart)) {
                    const match = item.variant_title.match(/(\d+) Pack/);
                    if (match) {
                        beerPacks.push({
                            id,
                            quantity: parseInt(match[1])
                        });
                    }
                }

                //here I searched for wine cases, is it cases in title
                let wineCase = [];
                for (const [id, item] of Object.entries(itemsInCart)) {
                    const match = item.variant_title.match(/Case of (\d+)/);
                    if (match) {
                        wineCase.push({
                            id,
                            quantity: parseInt(match[1])
                        });
                    }
                }
                //here I searched for wine MIX cases, is it cases in tags
                let wineMixCase = [];
                for (const [id, item] of Object.entries(itemsInCart)) {
                    const match = item.tags.includes('mixcase6') || item.tags.includes('mixcase12');
                    if (match) {
                        wineMixCase.push({
                            id,
                            quantity: item.tags.includes('mixcase6') ? 6 : 12
                        });
                    }
                }

                //here I took from liquid all items in cart
                const cartItems = data.items;

                for (const item of cartItems) {

                    //here I searched is it id of pack of beer or case of wine equal to id that now in cycle and then I'll multiply by this number(for example selectedBeerPack.quantity)
                    const selectedBeerPack = beerPacks.find(pack => parseFloat(pack.id) === parseFloat(item.id));
                    const selectedWineCase = wineCase.find(pack => parseFloat(pack.id) === parseFloat(item.id));
                    const selectedWineMixCase = wineMixCase.find(pack => parseFloat(pack.id) === parseFloat(item.id));


                    //calories
                    let itemCalories = parseFloat(itemsInCart[item.id].caloriesProduct);
                    if (isNaN(itemCalories)) {
                        itemCalories = parseFloat(itemsInCart[item.id].caloriesVariant);
                    }

                    if (!isNaN(itemCalories)) {
                        let caloriesSavingProduct = itemCalories;

                        if (itemsInCart[item.id].tags.includes('wine calories')) {
                            caloriesSavingProduct = 678 - itemCalories;
                        } else if (itemsInCart[item.id].tags.includes('ipa calories')) {
                            caloriesSavingProduct = 161 - itemCalories;
                        } else if (itemsInCart[item.id].tags.includes('pils calories')) {
                            caloriesSavingProduct = 161 - itemCalories;
                        } else if (itemsInCart[item.id].tags.includes('lager calories')) {
                            caloriesSavingProduct = 137 - itemCalories;
                        } else if (itemsInCart[item.id].tags.includes('spirit calories')) {
                            caloriesSavingProduct = 1708 - itemCalories;
                        }

                        if (selectedBeerPack) {
                            const quantityMatch = selectedBeerPack.quantity * item.quantity;
                            caloriesSavingProduct *= quantityMatch;
                        } else if (selectedWineCase) {
                            const quantityMatch = selectedWineCase.quantity * item.quantity;
                            caloriesSavingProduct *= quantityMatch;
                        } else if (selectedWineMixCase) {
                            const quantityMatch = selectedWineMixCase.quantity * item.quantity;
                            caloriesSavingProduct *= quantityMatch;
                        } else {
                            caloriesSavingProduct *= item.quantity;
                        }

                        total_saving_calories_cart += caloriesSavingProduct;
                    }

                    //sugars
                    let itemSugars = parseFloat(itemsInCart[item.id].SugarProduct);
                    if (isNaN(itemSugars)) {
                        itemCalories = parseFloat(itemsInCart[item.id].SugarVariant);
                    }

                    if (!isNaN(itemSugars)) {
                        let sugarsSavingProduct = itemSugars;

                        if (itemsInCart[item.id].tags.includes('wine sugars')) {
                            sugarsSavingProduct = 20 - itemSugars;
                        }

                        if (selectedBeerPack) {
                            const quantityMatch = selectedBeerPack.quantity * item.quantity;
                            sugarsSavingProduct *= quantityMatch;
                        } else if (selectedWineCase) {
                            const quantityMatch = selectedWineCase.quantity * item.quantity;
                            sugarsSavingProduct *= quantityMatch;
                        } else if (selectedWineMixCase) {
                            const quantityMatch = selectedWineMixCase.quantity * item.quantity;
                            sugarsSavingProduct *= quantityMatch;
                        } else {
                            sugarsSavingProduct *= item.quantity;
                        }

                        total_saving_sugars_cart += sugarsSavingProduct;
                    }
                    //carbs
                    let itemCarbs = parseFloat(itemsInCart[item.id].CarbsProduct);
                    if (isNaN(itemCarbs)) {
                        itemCarbs = parseFloat(itemsInCart[item.id].CarbsVariant);
                    }
                    if (!isNaN(itemCarbs)) {
                        let carbsSavingProduct = itemCarbs;

                        if (itemsInCart[item.id].tags.includes('ipa carbs')) {
                            carbsSavingProduct = 15 - itemCarbs;
                        } else if (itemsInCart[item.id].tags.includes('pils carbs')) {
                            carbsSavingProduct = 15 - itemCarbs;
                        } else if (itemsInCart[item.id].tags.includes('lager carbs')) {
                            carbsSavingProduct = 12 - itemCarbs;
                        }

                        if (selectedBeerPack) {
                            const quantityMatch = selectedBeerPack.quantity * item.quantity;
                            carbsSavingProduct *= quantityMatch;
                        } else if (selectedWineCase) {
                            const quantityMatch = selectedWineCase.quantity * item.quantity;
                            carbsSavingProduct *= quantityMatch;
                        } else if (selectedWineMixCase) {
                            const quantityMatch = selectedWineMixCase.quantity * item.quantity;
                            carbsSavingProduct *= quantityMatch;
                        } else {
                            carbsSavingProduct *= item.quantity;
                        }

                        total_saving_carbs_cart += carbsSavingProduct;
                    }
                }

                let totalCaloriesElement = document.querySelector('.total-cal-element');
                let totalSugarsElement = document.querySelector('.total-sug-element');
                let totalCarbsElement = document.querySelector('.total-carbs-element');

                if (total_saving_calories_cart > 0) {
                    totalCaloriesElement.innerHTML = Math.ceil(total_saving_calories_cart) + ' Calories';
                }
                if (total_saving_sugars_cart > 0) {
                    totalSugarsElement.innerHTML = Math.ceil(total_saving_sugars_cart) + 'g' + ' Sugars';
                }
                if (total_saving_carbs_cart > 0) {
                    totalCarbsElement.innerHTML = Math.ceil(total_saving_carbs_cart) + 'g' + ' Carbs';
                }

                if (totalSugarsElement) {
                    if (totalSugarsElement.innerHTML || totalCarbsElement.innerHTML) {
                        totalCaloriesElement.innerHTML += ',';
                    }
                }
                if (totalSugarsElement) {
                    if (totalSugarsElement.innerHTML && totalCarbsElement.innerHTML) {
                        totalSugarsElement.innerHTML += ',';
                    }
                }
            })
            .catch(error => error)
    }

    function ajaxUpdateSellingPlan(lineID, sellingPlan, quantity) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {selling_plan: sellingPlan, line: lineID, quantity: quantity},
            success: function () {
                cartDrawerUpdateMarkup();
            }
        });
    }

    function upgradeToSubscription() {
        let sellingPlan = '';
        const checkbox = $(this)
        const lineId = checkbox.data('line-id')
        const quantity = Number(checkbox.data('quantity'))
        const cartSubscriptionUpgradeBlock = checkbox.parents('.cart-subscription-upgrade')

        if (checkbox.is(':checked')) {
            cartSubscriptionUpgradeBlock.addClass('active');
            cartSubscriptionUpgradeBlock.siblings('.cart-subscription-plan').addClass('active');
            sellingPlan = cartSubscriptionUpgradeBlock.siblings('.cart-subscription-plan').find('select').val();
        } else {
            cartSubscriptionUpgradeBlock.removeClass('active');
            cartSubscriptionUpgradeBlock.siblings('.cart-subscription-plan').removeClass('active');
            sellingPlan = '';
        }
        ajaxUpdateSellingPlan(lineId, sellingPlan, quantity);
    }

    document.addEventListener('rebuy.add', rebuyAddedProduct)
    document.addEventListener('rebuy.remove', rebuyRemovedProduct)
    $('.cart-open').on('click', cartDrawerOpen)
    $('form[action$="/cart/add"]').on('submit', addToCart)
    $(document).on('recommendedUpdate', 'filterGridUpdate', function () {
        $('form[action$="/cart/add"]').off('submit', addToCart).on('submit', addToCart)
    })
    $(document).on('filterGridUpdate', function () {
        $('form[action$="/cart/add"]').off('submit', addToCart).on('submit', addToCart)
    })

    caloriesProcess()

    // function setFullHeight() {
    //   const fullHeightDiv = document.querySelector('.cart-drawer');
    //   fullHeightDiv.style.height = `${window.innerHeight}px`;
    //   console.log(`${window.innerHeight}px`)
    // }
    //
    // window.addEventListener('resize', setFullHeight);
    // window.addEventListener('orientationchange', setFullHeight);
    //
    // // Встановлюємо висоту при першому завантаженні сторінки
    // setFullHeight();


    // Promo process

    const setCookie = (sCookieName, sCookieContents, iCookieLength, tlDomain) => {
        let dCookieExpires = new Date();
        dCookieExpires.setTime(dCookieExpires.getTime() + (iCookieLength * 24 * 60 * 60 * 1000));
        document.cookie = sCookieName + "=" + sCookieContents + "; expires=" + dCookieExpires.toGMTString() + ";domain=" + tlDomain + "; path=/;";
    };

    const getCookie = (sCookieName) => {
        sCookieName += "=";
        let aCookies = document.cookie.split(";");
        for (let i = 0; i < aCookies.length; i++) {
            while (aCookies[i].charAt(0) == " ") aCookies[i] = aCookies[i].substring(1);
            if (aCookies[i].indexOf(sCookieName) != -1) {
                return aCookies[i].substring(sCookieName.length, aCookies[i].length);
            }
        }
    };

    const rebuildCart = () => {
        window.rfd.renderCart(true, window.rfd.enableBtns);
    }

    const giftProductProcess = () => {
        // let giftProductIDS = [
        //   44376736104668, //Size M DrinkWell Bundle
        //   44376748982492, //  Size L DrinkWell Bundle
        //   44376754520284, // Size XL DrinkWell Bundle
        // ];

        let giftProductIDS = [];

        $('.gift-product-variants option').each(function () {
            giftProductIDS.push(parseInt($(this).val()));
        });

        $('.gift-product-item').each(function () {
            giftProductIDS.push(parseInt($(this).data('variant-id')));
        });

        // console.log('giftProductIDS', giftProductIDS)

        if (!getCookie('giftModalClosed')) {
            fetch('/cart.js')
                .then(response => response.json())
                .then((cart) => {
                    let productsAddData = [];
                    let productsUpdateData = {};

                    let giftProduct = cart.items.filter(item => giftProductIDS.includes(item.id));
                    let modalCartThresholdReal = window.modalCartThreshold * 100;

                    if (window.show1tshirt) {
                        if (cart.item_count >= 1 && cart.total_price > modalCartThresholdReal) {
                            if (giftProduct.length === 0) {
                                $('.gift-modal').addClass('active');
                            }
                        } else {
                            if (giftProduct.length !== 0) {
                                productsUpdateData[giftProduct[0]?.id] = 0
                            }
                        }
                    }
                    if (window.show5promo) {
                        if (checkWineRedCollection(cart.items)) {
                            $('.gift-modal').addClass('active');
                        }
                    }


                    return [productsAddData, productsUpdateData];
                })
                .then(async (data) => {
                    let [productsAddData, productsUpdateData] = data;

                    if (productsAddData.length > 0) {
                        await $.post('/cart/add.js', {
                            items: productsAddData
                        }).done(() => {
                            const currentCartCount = getCurrentCartCount()
                            cartDrawerUpdateMarkup(currentCartCount + 1)
                        })
                    }
                    if (Object.values(productsUpdateData).length > 0) {
                        await $.post('/cart/update.js', {
                            updates: productsUpdateData
                        })
                    }

                    if (productsAddData.length > 0 || Object.values(productsUpdateData).length > 0) {
                        const currentCartCount = getCurrentCartCount()
                        cartDrawerUpdateMarkup(currentCartCount + 1);
                    }

                });
        }
    }

    giftProductProcess();

    $(document).on('cartUpdated', giftProductProcess);

    $('.modal-close').on('click', function () {
        $(this).parents('.gift-modal').removeClass('active')
        setCookie('giftModalClosed', true, 1, 'drinkwelluk.com')
    })

    // for bottles:

    $('.gift-product-item').on('click', function () {
        $('.gift-product-item').removeClass('selected')
        $(this).addClass('selected')
    })

    $('.gift-product-atc').on('click', function () {
        let variantId;

        if (window.show1tshirt) {
            // For 1 T-Shirt
            variantId = $('.gift-product-variants').val();
        } else {
            // For more than 1 T-Shirt
            variantId = $('.gift-product-item.selected').data('variant-id');
        }

        $.post('/cart/add.js', {
            items: [{
                id: variantId,
                quantity: 1,
                properties: {
                    '_gift_product': true
                }
            }]
        }).done(() => {
            const currentCartCount = Number($('.header__icons-item-icon-cart-count').text());
            cartDrawerUpdateMarkup(currentCartCount + 1)
            $('.gift-modal').removeClass('active')
        })
    })


//   for drinkwellClub page Join now button:
    $('.dwc-atc').on('click', function () {
        $('.dwc-atc').attr('disabled', 'disabled');
        let variantId = $(this).data('variant-id');
        let sellingPlanId = $(this).data('selling-plan');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                        selling_plan: sellingPlanId
                    }
                ]
            })
        })
            .then(response => response.json())
            .then(data => {
                const currentCartCount = Number($('.header__icons-item-icon-cart-count').text());
                cartDrawerUpdateMarkup(currentCartCount + 1).then(() => {
                    cartDrawerOpen();
                    $('.dwc-atc').removeAttr('disabled');
                });
            })
    })


//   for collection promo Wine bottle(or any other)
    function checkWineRedCollection(cartItems) {
        let productCount = 0;
        const collectionProductIds = window.collectionPromo.map(product => product.id);

        cartItems.forEach(item => {
            // console.log('item.product_id', item.product_id)
            if (collectionProductIds.includes(item.product_id)) {
                productCount += item.quantity;
            }
        });

        // console.log('productCount', productCount)
        return productCount >= 4;
    }

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('.gift-modal').hasClass('active')) {
            $('.gift-modal').removeClass('active');
        }
    });
    $(document).on('click', function (e) {
        if ($(e.target).closest('.gift-modal-content').length === 0 && $('.gift-modal').hasClass('active')) {
            $('.gift-modal').removeClass('active');
        }
    });

// infinite scroll

  var $win = $(window);
  var $productsContainer = $('#product-grid');
  var $pagination = $('.AjaxinatePagination');
  var loading = false;
  if ($productsContainer.length && $pagination.length) {
    function loadMoreProducts() {
      if (loading) return;
      loading = true;
      var nextPageUrl = $('.AjaxinatePagination').find('a[rel="next"]').attr('href');
      if (!nextPageUrl) {
        loading = false;
        return;
      }
      $.ajax({
        url: nextPageUrl,
        type: 'GET',
        success: function(data) {
          var $newProducts = $(data).find('#product-grid .product-card');
          var $newPagination = $(data).find('.AjaxinatePagination');
          $('#product-grid').append($newProducts);
          $('.AjaxinatePagination').html($newPagination.html());
          $pagination = $('.AjaxinatePagination');
          loading = false;
          checkScroll();
          $('form[action$="/cart/add"]').off('submit', addToCart).on('submit', addToCart);
          $('form[action$="/cart/add"]').on('submit', addToCart)
        },
        error: function() {
          console.error('Failed to load more products.');
          loading = false;
        }
      });
    }
  
    function isElementInViewport(el) {
      var rect = el[0].getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  
    function checkScroll() {
      if (isElementInViewport($pagination) || ($win.scrollTop() + $win.height() >= $(document).height() - 100)) {
        loadMoreProducts();
      }
    }
  
    $win.on('scroll', checkScroll);
    checkScroll();
  }
})
